import { useLang } from "@/lib/i18n";

export default function Splash() {
  const { t } = useLang();
  return (
    <div className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-background text-primary">
      <div className="pulse-soft">
        <img src="/logo.png" alt="Al Qalaa International Group" className="h-28 w-auto" />
      </div>
      <p className="mt-6 text-xs tracking-[0.45em] uppercase text-muted-foreground">Al Qalaa International Group</p>
      <span className="sr-only">{t("nav_home")}</span>
    </div>
  );
}
